import React from 'react'
import agent from '../agent'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { Link } from 'react-router-dom'
import {
    PRODUCT_DETAIL_PAGE_LOADED,
    PRODUCT_DETAIL_PAGE_UNLOADED,
} from '../constants/actionTypes'
import { store } from '../store'
import { push } from 'react-router-redux'
import ProductLogList from './widgets/ProductLogList'

const Promise = global.Promise;

const mapStateToProps = state => ({
    ...state.product,
    currentUser: state.common.currentUser,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: PRODUCT_DETAIL_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: PRODUCT_DETAIL_PAGE_UNLOADED }),
});

class ProductDetail extends React.Component {
    constructor() {
        super()
    }

    componentWillMount() {
        const payload = Promise.all([
            agent.Products.getDetail(this.props.match.params.key),
            agent.Products.getProductLogs(this.props.match.params.key)
        ])
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        if (!this.props.product) {
            return (
                <Loading />
            )
        }

        return (
            <div class='pane'>
                <Link className="crumb" to={`/products/user/${this.props.product.userkey}`}>&laquo; back to products</Link>
                <h1>Product Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span><Link to={`/product/${this.props.product.key}/edit`}>{this.props.product.key}</Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Name:</label> <span>{this.props.product.name}</span>
                    </div>
                    <div className="infoPair">
                        <label>Price:</label> <span>{this.props.product.price}</span>
                    </div>
                    <div className="infoPair">
                        <label>Currency:</label> <span>{this.props.product.currency}</span>
                    </div>
                    <div className="infoPair">
                        <label>Category:</label> <span>{this.props.product.category_name}</span>
                    </div>
                </div>
                <div className="infoGroup">
                    <div className="infoAction">
                        <h2>Update Logs</h2>
                        <ProductLogList logs={this.props.logs} loading={this.props.loading} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js